import { lazy } from 'react';
import type { RouteObject } from 'react-router';

const ReportsLayout = lazy(() => import('../../layouts/ReportsLayout'));
const BillReport = lazy(() => import('./bills/Bill'));
const BillsByMonth = lazy(() => import('./bills/BillsByMonth'));
const PaymentPeriodSummary = lazy(
  () => import('./payments/PaymentPeriodSummary'),
);
const Analytics = lazy(() => import('./analytics/Analytics'));

export const reportRoutes: RouteObject[] = [
  {
    path: 'reports',
    element: <ReportsLayout />,
    children: [
      { path: 'analytics', element: <Analytics /> },
      { path: 'bills/:billId', element: <BillReport /> },
      { path: ':month/bills', element: <BillsByMonth /> },
      { path: ':month/payments', element: <PaymentPeriodSummary /> },
    ],
  },
];
